
import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

export const SuccessFeedbackForm: React.FC = () => {
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!message.trim()) {
      toast.error('Vennligst skriv en melding');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      console.log('Sending suggestion with message:', message);
      
      // Call the Supabase function to send suggestion
      const { data, error } = await supabase.functions.invoke('send-suggestion', {
        body: { 
          message: message.trim(),
          senderEmail: 'Ingen e-post oppgitt',
          senderName: 'Bruker fra suksesssiden'
        }
      });

      if (error) {
        console.error('Error from send-suggestion function:', error);
        throw error;
      }
      
      console.log('Suggestion sent successfully:', data);
      toast.success('Takk for din melding!');
      setMessage('');
    } catch (error) {
      console.error('Error sending suggestion:', error);
      toast.error('Kunne ikke sende meldingen. Prøv igjen senere.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="border-t pt-8 mt-8 text-left">
      <p className="text-gray-700 mb-4">
        Har du kjennskap til temaer som burde belyses eller kanskje en kollega som ønsker å formidle noe av samfunnsinteresse? Tips oss gjerne! Epost: redaksjonen@briefr.no eller legg igjen en beskjed her:
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <Textarea
          placeholder="Skriv din melding her..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full min-h-[100px] resize-y"
          required
        />
        
        <div className="flex justify-end">
          <Button 
            type="submit"
            className="bg-[#ea384c] hover:bg-[#ea384c]/90 text-white flex items-center gap-2"
            disabled={isSubmitting || !message.trim()}
          >
            <Send className="h-4 w-4" />
            {isSubmitting ? 'Sender...' : 'Send inn'}
          </Button>
        </div>
      </form>
    </div>
  );
};
